import { render, staticRenderFns } from "./RobotControl.vue?vue&type=template&id=0c38498f&scoped=true"
import script from "./RobotControl.vue?vue&type=script&lang=js"
export * from "./RobotControl.vue?vue&type=script&lang=js"
import style0 from "./RobotControl.vue?vue&type=style&index=0&id=0c38498f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c38498f",
  null
  
)

export default component.exports